import { render } from "./TheUserRentals.vue?vue&type=template&id=7d4011c0"
import script from "./TheUserRentals.vue?vue&type=script&lang=js"
export * from "./TheUserRentals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__